import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_KaratsubaMultiplication = () => (
  <DAAModuleSubtopic
    title="Divide and Conquer – Karatsuba Multiplication"
    videos={[
      "https://www.youtube.com/embed/yWI2K4jOjFQ",
      "https://www.youtube.com/embed/7_opFwubodM"
    ]}
    takeaways={[
      {
        text: "Karatsuba reduces the number of multiplications from 4 to 3 using clever algebra, improving efficiency for large integer multiplication."
      },
      { image: "/Karatsuba.png"},
      {
        text: "Time Complexity: T(n) = 3T(n/2) + O(n) → O(n^log₂3) ≈ O(n^1.585), much faster than naive O(n²)."
      },
      {
        text: "Efficient for multiplying large numbers and foundational to fast multiplication algorithms."
      }
    ]}
    questions={[
      {
        text: "Design and develop an algorithm to multiply 2 integers and analyze their time complexity. Explain the technique using inputs 1234 and 4321."
      },
      {
        text: "Explain the efficiency of Karatsuba time complexity over naive multiplication. Perform multiplication of 1234 * 4321 using Karatsuba algorithm."
      },
      {
        text: "Multiply 1234 × 2326 using Karatsuba algorithm. Show valid and invalid recursive calls. Draw the recursion tree."
      },
      {
        text: "Design and develop an algorithm to multiply 2 integers and analyze their time complexity. Illustrate with 1334 and 1253."
      },
      {
        text: "Use divide and conquer strategy to multiply 38409 and 83329. Derive the recurrence relation and compute the time complexity. Also compute estimated time taken."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DAA_KaratsubaMultiplication ;
